import { apiSlice } from '../../../apis/api';
import { Stores2Collection } from '../../../swagger/collections';
import { getTags } from '../../../apis/apiLib';
import { YPickStoreCredentialsResponse } from '@ydistri/api-sdk';

const { TAGS, TAGS_ARRAY } = getTags('yPickCredentialsAdministration');

export const apiYPickCredentials = apiSlice
  .enhanceEndpoints({
    addTagTypes: TAGS_ARRAY,
  })
  .injectEndpoints({
    endpoints: builder => ({
      // eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void type
      getYPickCredentials: builder.query<YPickStoreCredentialsResponse[], void>({
        queryFn: async () => {
          const { data } = await Stores2Collection.getStoresYPickCredentials();
          return { data: data.data };
        },
        providesTags: [TAGS.yPickCredentials],
      }),
      // eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- result may be void here
      getYPickLoginQRCode: builder.query<Blob | void, number>({
        queryFn: async storeId => {
          const response = await Stores2Collection.getStoreYPickLoginQrCode(storeId, {
            format: 'blob',
          });
          const blob = response.data;
          return { data: blob };
        },
        providesTags: (result, error, storeId) => [{ type: TAGS.yPickCredentials, id: storeId }],
      }),
      // eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- result may be void here
      getAllYPickLoginQrCodes: builder.query<Blob | void, void>({
        queryFn: async () => {
          const response = await Stores2Collection.getAllYPickLoginQrCodes({
            format: 'blob',
          });
          const blob = response.data;
          return { data: blob };
        },
        providesTags: [TAGS.yPickCredentialsAll],
      }),
    }),
  });

export const {
  useGetYPickCredentialsQuery,
  useGetYPickLoginQRCodeQuery,
  useLazyGetYPickLoginQRCodeQuery,
  useLazyGetAllYPickLoginQrCodesQuery,
} = apiYPickCredentials;
